<template>
  <div class="pb-2">
    <driving-details-modal ref="DrivingDetailsModal" />
    <waste-collection-order-preview-modal
      ref="WasteCollectionOrderPreviewModal"
    />
    <b-card no-body>
      <div class="p-2 d-flex justify-content-between">
        <div class="d-flex justify-content-start">
          <div class="mr-2">
            <label for="example-datepicker">{{
              T("Web.Generic.PeriodFrom", "Period from")
            }}</label>
            <b-form-datepicker
              v-model="fromDate"
              placeholder="YYYY-MM-DD"
              :date-format-options="{
                year: 'numeric',
                month: 'numeric',
                day: 'numeric',
              }"
              @input="handleTimeSpanChanged"
            />
          </div>
          <div>
            <label for="example-datepicker">{{
              T("Web.Generic.PeriodTo", "Period to")
            }}</label>
            <b-form-datepicker
              v-model="toDate"
              :date-format-options="{
                year: 'numeric',
                month: 'numeric',
                day: 'numeric',
              }"
              @input="handleTimeSpanChanged"
            />
          </div>
        </div>
        <div class="d-flex">
          <b-form-input
            class="search-input mr-1"
            :placeholder="T('Web.Generic.Search')"
            v-model="searchTerm"
            debounce="300"
          />
          <div>
            <driving-reporting-filter-drop-down
              v-if="tableFilters != null"
              :key="filtersVersion"
              v-model="tableFilters"
              :type-options="typeFilterOptions"
              :collectors-options="collectorsFilterOptions"
              :origins-options="originFilterOptions"
              :destinations-options="destinationFilterOptions"
              :containers-options="containerFilterOptions"
              :double-driving-candidat-options="
                doubleDrivingCandidateFilterOptions
              "
            />
          </div>
          <b-dropdown class="ml-1 align-self-center" text="Eksporter" right>
            <b-dropdown-item @click="exportData">Kørsler</b-dropdown-item>
            <b-dropdown-item @click="exportOrders">Ordrer</b-dropdown-item>
          </b-dropdown>
        </div>
      </div>
      <page-loader :loading="isLoading">
        <div>
          <div class="table-con">
            <b-table-simple small>
              <b-thead>
                <b-tr>
                  <b-th>Transport id</b-th>
                  <b-th
                    ><sortable-column-text
                      text="Transportør"
                      sortKey="supplierName"
                      v-model="activeSortItem"
                  /></b-th>
                  <b-th
                    ><sortable-column-text
                      text="Type"
                      sortKey="type"
                      v-model="activeSortItem"
                  /></b-th>
                  <b-th>
                    <sortable-column-text
                      text="Mulig dobbeltkørsel"
                      sortKey="possibleDoubleDriving"
                      v-model="activeSortItem"
                    />
                  </b-th>
                  <b-th>
                    <sortable-column-text
                      text="Påbegyndt"
                      sortKey="startTime"
                      v-model="activeSortItem"
                    />
                  </b-th>
                  <b-th>
                    <sortable-column-text
                      text="Afsluttet"
                      sortKey="closedAt"
                      v-model="activeSortItem"
                    />
                  </b-th>
                  <b-th> Rekvisitionsnummer </b-th>
                  <b-th>
                    <sortable-column-text
                      text="Bestillingstidspunkt"
                      sortKey="orderingTime"
                      v-model="activeSortItem"
                    />
                  </b-th>
                  <b-th>
                    <sortable-column-text
                      text="Fraktion"
                      sortKey="fraction"
                      v-model="activeSortItem"
                    />
                  </b-th>
                  <b-th>
                    <sortable-column-text
                      text="Kg kørt"
                      sortKey="kgCollected"
                      v-model="activeSortItem"
                    />
                    {{ totalKgSum | toCurrency }}
                  </b-th>
                  <b-th>
                    <sortable-column-text
                      text="Afhentingssted"
                      sortKey="PickupLocation"
                      v-model="activeSortItem"
                    />
                  </b-th>
                  <b-th>
                    <sortable-column-text
                      text="Modtageranlæg"
                      sortKey="RecivingFacility"
                      v-model="activeSortItem"
                    />
                  </b-th>
                  <b-th>
                    <sortable-column-text
                      text="Price"
                      sortKey="price"
                      v-model="activeSortItem"
                  /></b-th>
                  <b-th>
                    <sortable-column-text
                      text="Tillægspris"
                      sortKey="addonPrice"
                      v-model="activeSortItem"
                    />
                  </b-th>
                  <b-th>
                    <sortable-column-text
                      text="Total pris"
                      sortKey="totalPrice"
                      v-model="activeSortItem"
                    />
                    {{ totalPriceSum | toCurrency }}
                  </b-th>
                  <b-th>
                    <sortable-column-text
                      text="Mulig besparelse"
                      sortKey="potentialDoubleDrivingSavings"
                      v-model="activeSortItem"
                    />
                    {{ potentialSavingsSum | toCurrency }}
                  </b-th>
                  <b-th>Faktureret i</b-th>
                  <b-th></b-th>
                </b-tr>
              </b-thead>
              <tbody>
                <template v-for="(transport, index) in pagedTransports">
                  <tr
                    :key="`${transport.id}_1`"
                    :class="{
                      'light-gray': index % 2 == 0,
                    }"
                  >
                    <td :rowspan="transport.type == 'Solo' ? 1 : 2">
                      {{ transport.transportId }}
                    </td>
                    <td :rowspan="transport.type == 'Solo' ? 1 : 2">
                      {{ transport.supplierName }}
                    </td>
                    <td :rowspan="transport.type == 'Solo' ? 1 : 2">
                      <small>{{ transport.typeText }}</small>
                    </td>
                    <td :rowspan="transport.type == 'Solo' ? 1 : 2">
                      <small v-if="transport.type == 'Solo'">{{
                        transport.possibleDoubleDrivingText
                      }}</small>
                      <div
                        v-if="transport.shownDoubleDrivingCandidates.length > 0"
                        class="double-driving-candidates"
                      >
                        <small>
                          <a
                            v-for="candidate in transport.shownDoubleDrivingCandidates"
                            :key="candidate.id"
                            href="#"
                            class="d-block"
                            :title="getCandidateTitle(candidate)"
                            @click.prevent="openOrderPreviewModal(candidate.id)"
                            >{{ candidate.requisitionId }}</a
                          >
                          <a
                            v-if="
                              transport.hiddenDoubleDrivingCandidateCount > 0
                            "
                            href="#"
                            class="d-block text-muted"
                            @click.prevent="
                              openDrivingDetailsModal(transport.id)
                            "
                            >+{{
                              transport.hiddenDoubleDrivingCandidateCount
                            }}</a
                          >
                        </small>
                      </div>
                    </td>

                    <td :rowspan="transport.type == 'Solo' ? 1 : 2">
                      <small>{{ format_datetime(transport.startTime) }}</small>
                    </td>
                    <td :rowspan="transport.type == 'Solo' ? 1 : 2">
                      <small>{{ format_datetime(transport.closedAt) }}</small>
                    </td>
                    <td>
                      <small
                        ><a
                          href="#"
                          @click="
                            openOrderPreviewModal(transport.primaryOrder_Id)
                          "
                        >
                          {{ transport.primaryOrder_RequisitionId }}</a
                        ></small
                      >
                    </td>
                    <td>
                      <small>{{
                        format_datetime(transport.primaryOrder_OrderTime)
                      }}</small>
                    </td>
                    <td>
                      <small>{{ transport.primaryOrder_FractionName }}</small>
                    </td>
                    <td>
                      <small>{{
                        transport.primaryOrder_KgCollected | toCurrency
                      }}</small>
                    </td>
                    <td>
                      <small>{{
                        transport.primaryOrder_PickupLocationName
                      }}</small>
                    </td>
                    <td>
                      <small>{{
                        transport.primaryOrder_ReceivingFacilityName
                      }}</small>
                    </td>
                    <td :rowspan="transport.type == 'Double' ? 2 : 1">
                      {{ transport.primaryOrder_Price | toCurrency }}
                    </td>
                    <td :rowspan="transport.type == 'Double' ? 2 : 1">
                      {{ transport.primaryOrder_AdditionalPrice | toCurrency }}
                    </td>
                    <td :rowspan="transport.type == 'Solo' ? 1 : 2">
                      {{ transport.totalPrice | toCurrency }}
                    </td>
                    <td :rowspan="transport.type == 'Solo' ? 1 : 2">
                      <template
                        v-if="transport.potentialDoubleDrivingSavings > 0"
                      >
                        {{
                          transport.potentialDoubleDrivingSavings | toCurrency
                        }}
                        <feather-icon
                          v-if="transport.savingsExplanation"
                          v-b-tooltip.hover.top="{
                            title: transport.savingsExplanation,
                            customClass: 'savings-explanation-tooltip',
                          }"
                          icon="InfoIcon"
                          size="14"
                          class="ml-25 text-muted savings-info-icon"
                        />
                      </template>
                    </td>
                    <td :rowspan="transport.type == 'Solo' ? 1 : 2">
                      <small>
                        <a
                          v-if="transport.invoiceNumber != null"
                          href="#"
                          @click.prevent="
                            downloadInvoiceAccountList(transport.invoiceNumber)
                          "
                          >{{ transport.invoiceNumber }}</a
                        >
                        <span v-else>Ej faktureret</span>
                      </small>
                    </td>
                    <td :rowspan="transport.type == 'Solo' ? 1 : 2">
                      <b-button
                        class="float-right"
                        variant="flat-secondary"
                        size="sm"
                        @click="openDrivingDetailsModal(transport.id)"
                      >
                        {{ showDetailsText }}
                      </b-button>
                    </td>
                  </tr>

                  <tr
                    :key="`${transport.id}_2`"
                    v-if="transport.type != 'Solo'"
                    :class="{
                      'light-gray': index % 2 == 0,
                    }"
                  >
                    <td style="padding-left: 0.5rem">
                      <small>
                        <a
                          href="#"
                          @click="
                            openOrderPreviewModal(transport.secondaryOrder_Id)
                          "
                        >
                          {{ transport.secondaryOrder_RequisitionId }}</a
                        >
                      </small>
                    </td>
                    <td>
                      <small>{{
                        format_datetime(transport.secondaryOrder_OrderTime)
                      }}</small>
                    </td>
                    <td>
                      <small>{{ transport.secondaryOrder_FractionName }}</small>
                    </td>
                    <td>
                      <small>{{
                        transport.secondaryOrder_KgCollected | toCurrency
                      }}</small>
                    </td>
                    <td>
                      <small>{{
                        transport.secondaryOrder_PickupLocationName
                      }}</small>
                    </td>
                    <td>
                      <small>{{
                        transport.secondaryOrder_ReceivingFacilityName
                      }}</small>
                    </td>
                    <td
                      v-if="
                        transport.type != 'Solo' && transport.type != 'Double'
                      "
                    >
                      {{ transport.secondaryOrder_Price | toCurrency }}
                    </td>
                    <td
                      v-if="
                        transport.type != 'Solo' && transport.type != 'Double'
                      "
                    >
                      {{
                        transport.secondaryOrder_AdditionalPrice | toCurrency
                      }}
                    </td>
                  </tr>
                </template>
              </tbody>
            </b-table-simple>
          </div>
          <div
            v-if="filteredTransports.length > perPage"
            class="d-flex justify-content-center pb-1"
          >
            <b-pagination
              v-model="currentPage"
              :total-rows="filteredTransports.length"
              :per-page="perPage"
            />
          </div>
        </div>
      </page-loader>
    </b-card>
  </div>
</template>

<script>
import * as XLSX from "xlsx";
import {
  BCard,
  BContainer,
  BFormDatepicker,
  BTable,
  BButton,
  BFormInput,
  BTableSimple,
  BThead,
  BTbody,
  BTr,
  BTh,
  BTd,
  BDropdown,
  BDropdownItem,
  BPagination,
  VBTooltip,
} from "bootstrap-vue";
import ResourceService from "@/services/base/resource.service";
import moment from "moment";
import DrivingDetailsModal from "./components/DrivingDetailsModal.vue";
import DrivingReportingFilterDropDown from "./components/DrivingReportingFilterDropDown.vue";
import WasteCollectionOrderPreviewModal from "@/app/concern-app/ordering/WasteCollectionOrderPreviewModal.vue";
import PageLoader from "@/app/components/layout/PageLoader.vue";
import SortableColumnText from "./components/SortableColumnText.vue";

// Same ordering as String.prototype.localeCompare(), but without re-resolving the locale per comparison
const collator = new Intl.Collator();
const compareText = (a, b) => collator.compare(a ?? "", b ?? "");
// Longer candidate lists are cut off in the table; the details modal shows them all
const MAX_SHOWN_DOUBLE_DRIVING_CANDIDATES = 5;

export default {
  components: {
    BFormDatepicker,
    BContainer,
    BCard,
    BTable,
    BButton,
    BFormInput,
    DrivingDetailsModal,
    DrivingReportingFilterDropDown,
    WasteCollectionOrderPreviewModal,
    PageLoader,
    BTableSimple,
    BThead,
    BTbody,
    BTr,
    BTh,
    BTd,
    BDropdown,
    BDropdownItem,
    SortableColumnText,
    BPagination,
  },
  directives: {
    "b-tooltip": VBTooltip,
  },
  data() {
    return {
      fromDate: this.getDefaultFromDateValue(),
      toDate: this.getDefaultToDateValue(),
      transports: [],

      data: [],
      searchTerm: "",
      tableFields: [
        {
          key: "transportId",
          label: this.T("Web.Generic.Id", "Id"),
          sortable: true,
        },

        {
          key: "primaryOrder.orderDate",
          label: this.T(
            "Web.Generic.Ordering.OrderingTime",
            "Time of ordering"
          ),
          sortable: true,
        },
        {
          key: "date",
          label: this.T("Web.Generic.Drivings.StartTime", "Start time"),
          sortable: true,
        },
        {
          key: "doubleDriving",
          label: this.T("Web.Generic.Type"),
          sortable: true,
        },

        {
          key: "supplierName",
          label: this.T("Web.Generic.Suppliers.Supplier", "Supplier"),
          sortable: true,
        },
        {
          key: "drivingOrigin",
          label: this.T("Web.Generic.Locations.Location", "Location"),
          sortable: true,
        },
        {
          key: "drivingDestination",
          label: this.T(
            "Web.Generic.Drivings.RecivingFacility",
            "Reciving facility"
          ),
          sortable: true,
        },
        {
          key: "primaryOrder.orderItemName",
          label: `${this.T("Web.Generic.Drivings.Container", "Container")} 1`,
          sortable: true,
        },
        {
          key: "secondaryOrder.orderItemName",
          label: `${this.T("Web.Generic.Drivings.Container", "Container")} 2`,
          sortable: true,
        },

        {
          key: "doubleDrivingCandidate",
          label: this.T(
            "Web.Generic.Drivings.PosibleDoubleDriving",
            "Posible double driving"
          ),
          sortable: true,
        },
        {
          key: "status",
          label: this.T("Web.Generic.Status", "Status"),
          sortable: true,
        },
        {
          key: "actions",
          label: "",
        },
      ],
      tableFilters: null,
      isLoading: false,
      fetchVersion: 0,
      filtersVersion: 0,
      currentPage: 1,
      perPage: 100,
      showDetailsText: this.T("Web.Generic.ShowDetails", "Show details"),
      activeSortItem: {
        sortKey: "closedAt",
        dir: "DESC",
      },
    };
  },
  async created() {
    await this.fetchTransports();
  },
  computed: {
    potentialSavingsSum() {
      return this.filteredTransports.reduce(
        (prev, curr) => prev + curr.potentialDoubleDrivingSavings,
        0
      );
    },
    totalPriceSum() {
      return this.filteredTransports.reduce(
        (prev, curr) => (prev += curr.totalPrice),
        0
      );
    },
    totalKgSum() {
      return this.filteredTransports.reduce(
        (prev, curr) =>
          (prev +=
            curr.secondaryOrder_KgCollected + curr.primaryOrder_KgCollected),
        0
      );
    },
    filteredTransports() {
      if (this.tableFilters == null) return [];
      const types = new Set(this.tableFilters.type);
      const collectors = new Set(this.tableFilters.collectors);
      const origins = new Set(this.tableFilters.origins);
      const destinations = new Set(this.tableFilters.destinations);
      const containers = new Set(this.tableFilters.containers);
      const doubleDrivingCandidates = new Set(
        this.tableFilters.doubleDrivingCandidates
      );
      const lowerSearchTerm = this.searchTerm.toLowerCase();

      /** Filters + search */
      const result = this.transports.filter(
        (i) =>
          types.has(i.typeText) &&
          collectors.has(i.supplierName) &&
          (origins.has(i.primaryOrder_PickupLocationName) ||
            origins.has(i.secondaryOrder_PickupLocationName)) &&
          (destinations.has(i.primaryOrder_ReceivingFacilityName) ||
            destinations.has(i.secondaryOrder_ReceivingFacilityName)) &&
          (containers.has(i.primaryOrder_FractionName) ||
            containers.has(i.secondaryOrder_FractionName)) &&
          doubleDrivingCandidates.has(i.possibleDoubleDrivingText) &&
          (lowerSearchTerm == "" || i.searchText.includes(lowerSearchTerm))
      );

      /** Sort */
      const dir = this.activeSortItem.dir == "DESC" ? -1 : 1;
      const sortKey = this.activeSortItem.sortKey;
      // Compares the primary order field, falling back to the secondary one for non-solo drivings
      const byOrderField = (field) => (a, b) => {
        const primaryComparison = compareText(
          a[`primaryOrder_${field}`],
          b[`primaryOrder_${field}`]
        );
        if (primaryComparison != 0 || a.type == "Solo" || b.type == "Solo")
          return primaryComparison;
        return compareText(
          a[`secondaryOrder_${field}`],
          b[`secondaryOrder_${field}`]
        );
      };
      const byNumber = (value) => (a, b) => value(a) - value(b);
      let comparer;
      switch (sortKey) {
        case "possibleDoubleDriving":
          comparer = (a, b) =>
            compareText(
              a.type != "Solo" ? "" : a.possibleDoubleDrivingText,
              b.type != "Solo" ? "" : b.possibleDoubleDrivingText
            );
          break;
        case "orderingTime":
          comparer = byOrderField("OrderTime");
          break;
        case "fraction":
          comparer = byOrderField("FractionName");
          break;
        case "PickupLocation":
          comparer = byOrderField("PickupLocationName");
          break;
        case "RecivingFacility":
          comparer = byOrderField("ReceivingFacilityName");
          break;
        case "kgCollected":
          comparer = byNumber(
            (i) => i.primaryOrder_KgCollected + i.secondaryOrder_KgCollected
          );
          break;
        case "price":
          comparer = byNumber(
            (i) => i.primaryOrder_Price + i.secondaryOrder_Price
          );
          break;
        case "addonPrice":
          comparer = byNumber(
            (i) =>
              i.primaryOrder_AdditionalPrice + i.secondaryOrder_AdditionalPrice
          );
          break;
        case "potentialDoubleDrivingSavings":
          comparer = byNumber((i) => i.potentialDoubleDrivingSavings);
          break;
        case "totalPrice":
          comparer = byNumber((i) => i.totalPrice);
          break;
        default:
          comparer = (a, b) => compareText(a[sortKey], b[sortKey]);
          break;
      }
      return result.sort((a, b) => dir * comparer(a, b));
    },
    pagedTransports() {
      const start = (this.currentPage - 1) * this.perPage;
      return this.filteredTransports.slice(start, start + this.perPage);
    },

    typeFilterOptions() {
      return [
        ...new Set(this.transports.map((i) => i.typeText).sort(compareText)),
      ];
    },
    collectorsFilterOptions() {
      return [
        ...new Set(
          this.transports.map((i) => i.supplierName).sort(compareText)
        ),
      ];
    },
    originFilterOptions() {
      let list = this.transports.map((i) => i.primaryOrder_PickupLocationName);
      list.concat(
        this.transports
          .filter((t) => t.secondaryOrder_PickupLocationName != null)
          .map((i) => i.secondaryOrder_PickupLocationName)
      );
      return [...new Set(list.sort((a, b) => a.localeCompare(b)))];
    },
    destinationFilterOptions() {
      let list = this.transports.map(
        (i) => i.primaryOrder_ReceivingFacilityName
      );
      list.concat(
        this.transports
          .filter((t) => t.secondaryOrder_ReceivingFacilityName != null)
          .map((i) => i.secondaryOrder_ReceivingFacilityName)
      );
      return [
        ...new Set(list.sort((a, b) => (a != null ? a.localeCompare(b) : -1))),
      ];
    },
    containerFilterOptions() {
      let containers = [
        ...this.transports.map((i) => i.primaryOrder_FractionName),
        ...this.transports
          .filter((i) => i.primaryOrder_FractionName != null)
          .map((i) => i.primaryOrder_FractionName),
      ];
      return [...new Set(containers.sort((a, b) => a.localeCompare(b)))];
    },
    doubleDrivingCandidateFilterOptions() {
      return [
        ...new Set(
          this.transports
            .map((i) => i.possibleDoubleDrivingText)
            .sort(compareText)
        ),
      ];
    },
  },
  methods: {
    async fetchTransports() {
      const fetchVersion = ++this.fetchVersion;
      this.isLoading = true;
      const service = new ResourceService("concern/orders/drivings");
      const transports = (
        await service.get("", {
          fromDate: this.fromDate,
          toDate: this.toDate,
        })
      ).data.data;
      // Changing both dates fires two requests; ignore the one that was superseded
      if (fetchVersion != this.fetchVersion) return;
      // Frozen so Vue doesn't make every row deeply reactive; rows are read-only here
      this.transports = Object.freeze(
        transports.map((t) => Object.freeze(this.toTransportRow(t)))
      );
      this.currentPage = 1;
      this.tableFilters = {
        type: this.typeFilterOptions,
        collectors: this.collectorsFilterOptions,
        origins: this.originFilterOptions,
        destinations: this.destinationFilterOptions,
        doubleDrivingCandidates: this.doubleDrivingCandidateFilterOptions,
        containers: this.containerFilterOptions,
      };
      // The filter dropdown copies its value on mount, so remount it with the new options
      this.filtersVersion++;
      this.isLoading = false;
    },
    toTransportRow(transport) {
      const isSolo = transport.type == "Solo";
      const searchableValues = [
        transport.transportId,
        transport.primaryOrder_RequisitionId,
        transport.primaryOrder_FractionName,
        transport.primaryOrder_PickupLocationName,
        transport.primaryOrder_ReceivingFacilityName,
        transport.invoiceNumber,
      ];
      if (!isSolo)
        searchableValues.push(
          transport.secondaryOrder_RequisitionId,
          transport.secondaryOrder_FractionName,
          transport.secondaryOrder_PickupLocationName,
          transport.secondaryOrder_ReceivingFacilityName
        );
      const candidates = transport.doubleDrivingCandidates ?? [];
      searchableValues.push(...candidates.map((c) => c.requisitionId));
      return {
        ...transport,
        doubleDrivingCandidates: candidates,
        potentialDoubleDrivingSavings:
          transport.potentialDoubleDrivingSavings ?? 0,
        shownDoubleDrivingCandidates: candidates.slice(
          0,
          MAX_SHOWN_DOUBLE_DRIVING_CANDIDATES
        ),
        hiddenDoubleDrivingCandidateCount: Math.max(
          0,
          candidates.length - MAX_SHOWN_DOUBLE_DRIVING_CANDIDATES
        ),
        savingsExplanation: this.getSavingsExplanation(candidates),
        typeText: this.getTypeText(transport.type),
        possibleDoubleDrivingText: this.getPossibleDoubleDrivingText(
          transport.possibleDoubleDriving
        ),
        searchText: searchableValues
          .filter((v) => v != null)
          .join("\n")
          .toLowerCase(),
      };
    },
    // Explains the saving of the best candidate, which is the saving shown for the driving
    getSavingsExplanation(candidates) {
      const best = candidates
        .filter((c) => c.savingsCalculation && c.potentialSavings > 0)
        .reduce(
          (a, b) =>
            a == null || b.potentialSavings > a.potentialSavings ? b : a,
          null
        );
      if (best == null) return null;
      const kr = this.$options.filters.toCurrency;
      const calc = best.savingsCalculation;
      const lines = [
        `Hvis ${best.requisitionId} (${best.orderItemName}${
          best.receivingFacilityName ? ` → ${best.receivingFacilityName}` : ""
        }) var taget med som dobbeltkørsel:`,
      ];
      if (calc.sameReceivingFacility) {
        lines.push(
          `To solokørsler: 2 × ${kr(calc.soloPrice)} = ${kr(
            2 * calc.soloPrice
          )}`,
          `Én dobbeltkørsel: ${kr(calc.doublePrice)}`,
          `Besparelse: ${kr(2 * calc.soloPrice)} − ${kr(
            calc.doublePrice
          )} = ${kr(calc.savings)}`
        );
      } else {
        const solos = calc.soloPrice + calc.candidateSoloPrice;
        const double =
          calc.partOfDoublePrice +
          calc.candidatePartOfDoublePrice +
          calc.betweenFacilitiesPrice;
        lines.push(
          `To solokørsler: ${kr(calc.soloPrice)} + ${kr(
            calc.candidateSoloPrice
          )} = ${kr(solos)}`,
          `Én dobbeltkørsel til 2 modtageranlæg: ${kr(
            calc.partOfDoublePrice
          )} + ${kr(calc.candidatePartOfDoublePrice)} + ${kr(
            calc.betweenFacilitiesPrice
          )} (mellem anlæg) = ${kr(double)}`,
          `Besparelse: ${kr(solos)} − ${kr(double)} = ${kr(calc.savings)}`
        );
      }
      if (candidates.length > 1)
        lines.push(
          `Største besparelse blandt ${candidates.length} mulige ordrer.`
        );
      return lines.join("\n");
    },
    getCandidateTitle(candidate) {
      const parts = [candidate.orderItemName];
      if (candidate.receivingFacilityName)
        parts.push(`→ ${candidate.receivingFacilityName}`);
      if (candidate.potentialSavings > 0)
        parts.push(
          `(mulig besparelse ${this.$options.filters.toCurrency(
            candidate.potentialSavings
          )})`
        );
      return parts.join(" ");
    },
    getTypeText(typeCode) {
      switch (typeCode) {
        case "Unknown":
          return "Ukendt";
        case "Solo":
          return "Solo";
        case "Double":
          return "Dobbelt";
        case "DoubleMultipleOrigins":
          return "Dobbelt (2 pladser)";
        case "DoubleMultipleDestinations":
          return "Dobbelt (2 modtageranlæg)";
        case "DoubleMultipleOriginsAndDestinations":
          return "Dobbelt (2 pladser & 2 modtageranlæg)";
      }
    },
    getPossibleDoubleDrivingText(value) {
      return value
        ? this.T("Web.Generic.YesOption", "Yes")
        : this.T("Web.Generic.NoOption", "No");
    },
    getStatus(item) {
      if (item.closedAt != null)
        return this.T("Web.Generic.Drivings.DrivingStatus.Closed", "Closed");
      if (item.deleteDate != null)
        return this.T("Web.Generic.Drivings.DrivingStatus.Cancled", "Cancled");
      if (item.unloadedAt != null)
        return this.T("Web.Generic.Drivings.DrivingStatus.Ongoing", "Ongoing");
      if (item.unloadedAt != null)
        return this.T(
          "Web.Generic.Drivings.DrivingStatus.Unloaded",
          "Unloaded"
        );
      return this.T("Web.Generic.Unknown", "Unknown");
    },

    async downloadInvoiceAccountList(invoiceNumber) {
      const service = new ResourceService(
        `concern/orders/drivings/account-list/${invoiceNumber}`
      );
      const data = (await service.get("")).data.data;

      const fileName = `kontofoderling_${invoiceNumber}.xlsx`;
      const modifiedData = data.map((item) => {
        return {
          Lokation: item.locationName,
          Fraktion: item.fractionName,
          "kontonr.": item.internalGroupId,
          "Tons i alt": item.tonnage.toFixed(3),
          "Antal Dobbeltkørsler": item.noOfDoubleDrivings.toFixed(1),
          "Antal Solokørsler": item.noOfSoloDrivings.toFixed(1),
          "Kr i alt": item.chargeTotal
            .toFixed(2)
            .toString()
            .replace(/(\d)\.(\d)/g, "$1,$2"),
        };
      });
      const worksheet = XLSX.utils.json_to_sheet(modifiedData);
      const workbook = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(workbook, worksheet, "Sheet 1");
      XLSX.writeFile(workbook, fileName);
    },

    exportData() {
      const fileName = `${this.fromDate}_${this.toDate}.xlsx`;
      const modifiedData = this.filteredTransports.map((item) => {
        return {
          "Transport id": item.transportId,
          Type: this.getTypeText(item.type),
          Påbegyndt: this.format_datetime(item.startTime),
          Afsluttet: this.format_datetime(item.closedAt),
          "Container 1 | Rekvisitionsnummer": item.primaryOrder_RequisitionId,
          "Container 1 | Bestillingstidspunkt": this.format_datetime(
            item.primaryOrder_OrderTime
          ),
          "Container 1 | Fraktion": item.primaryOrder_FractionName,
          "Container 1 | Kg kørt": item.primaryOrder_KgCollected,
          "Container 1 | Afhentingssted": item.primaryOrder_PickupLocationName,
          "Container 1 | Modtageranlæg":
            item.primaryOrder_ReceivingFacilityName,

          "Container 2 | Rekvisitionsnummer":
            item.type != "Solo" ? item.secondaryOrder_RequisitionId : "",
          "Container 2 | Bestillingstidspunkt":
            item.type != "Solo"
              ? this.format_datetime(item.secondaryOrder_OrderTime)
              : "",
          "Container 2 | Fraktion":
            item.type != "Solo" ? item.secondaryOrder_FractionName : "",
          "Container 2 | Kg kørt":
            item.type != "Solo" ? item.secondaryOrder_KgCollected : "",
          "Container 2 | Afhentingssted":
            item.type != "Solo" ? item.secondaryOrder_PickupLocationName : "",
          "Container 2 | Modtageranlæg":
            item.type != "Solo"
              ? item.secondaryOrder_ReceivingFacilityName
              : "",
          "Total pris": item.totalPrice.toFixed(2),
          "Mulig dobbeltkørsel":
            item.type == "Solo" ? item.possibleDoubleDrivingText : "",
          "Mulig besparelse": item.potentialDoubleDrivingSavings.toFixed(2),
          "Mulige ordrer til dobbeltkørsel": item.doubleDrivingCandidates
            .map((c) => c.requisitionId)
            .join(", "),
        };
      });
      const worksheet = XLSX.utils.json_to_sheet(modifiedData);
      const workbook = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(workbook, worksheet, "Sheet 1");
      XLSX.writeFile(workbook, fileName);
    },
    exportOrders() {
      const flatOrders = this.filteredTransports.flatMap((d) => {
        const primary = {
          transportor: d.primaryOrder_Transportor,
          refNr: d.primaryOrder_RequisitionId,
          fraktion: d.primaryOrder_FractionName,
          lokation: d.primaryOrder_PickupLocationName,
          prioritering: d.primaryOrder_Prioritering,
          bestiltKl: d.primaryOrder_OrderTime,
          afhentetKl: d.startTime,
          returnereretKl: d.primaryOrder_ContainerReturnedAt,
        };
        if (d.type === "Solo") return [primary];
        return [
          primary,
          {
            transportor: d.secondaryOrder_Transportor,
            refNr: d.secondaryOrder_RequisitionId,
            fraktion: d.secondaryOrder_FractionName,
            lokation: d.secondaryOrder_PickupLocationName,
            prioritering: d.secondaryOrder_Prioritering,
            bestiltKl: d.secondaryOrder_OrderTime,
            afhentetKl: d.startTime,
            returnereretKl: d.secondaryOrder_ContainerReturnedAt,
          },
        ];
      });

      const rows = flatOrders.map((o) => ({
        Transportør: o.transportor,
        "Ref.nr": o.refNr,
        Fraktion: o.fraktion,
        Lokation: o.lokation,
        Prioritering: o.prioritering,
        "Bestilt kl.": this.format_datetime(o.bestiltKl),
        "Afhentet kl.": this.format_datetime(o.afhentetKl),
        "Returneret kl.": this.format_datetime(o.returnereretKl),
      }));

      const worksheet = XLSX.utils.json_to_sheet(rows);
      const workbook = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(workbook, worksheet, "Ordrer");
      XLSX.writeFile(workbook, `ordrer_${this.fromDate}_${this.toDate}.xlsx`);
    },
    openDrivingDetailsModal(drivingId) {
      this.$refs.DrivingDetailsModal.open(drivingId);
    },
    async updateOrderKgWasteCollected(orderId, value) {
      const service = new ResourceService("concern/orders");
      await service.put(`${order.id}/kg-collected`, {
        kgWasteCollected: order.kgWasteCollected,
      });
      this.$bvToast.toast(`Kg opdateret på ${order.requisitionId} `, {
        title: this.T("Web.Generic.UpdateSuccessful", "Updated successfull"),
        autoHideDelay: 5000,
        appendToast: true,
      });
    },
    handleTimeSpanChanged() {
      localStorage.setItem("Rz_TransportReportingFromDateValue", this.fromDate);
      localStorage.setItem("Rz_TransportReportingToDateValue", this.toDate);

      //this.fetchDrivings();
    },
    getDefaultFromDateValue() {
      var localStorageValue = localStorage.getItem(
        "Rz_TransportReportingFromDateValue"
      );
      return localStorageValue
        ? localStorageValue
        : moment().startOf("month").format("YYYY-MM-DD");
    },
    getDefaultToDateValue() {
      var localStorageValue = localStorage.getItem(
        "Rz_TransportReportingToDateValue"
      );
      return localStorageValue
        ? localStorageValue
        : moment().endOf("day").format("YYYY-MM-DD");
    },
    openOrderPreviewModal(orderId) {
      this.$refs.WasteCollectionOrderPreviewModal.open(orderId);
    },
  },
  watch: {
    searchTerm() {
      this.currentPage = 1;
    },
    tableFilters: {
      deep: true,
      handler() {
        this.currentPage = 1;
      },
    },
    activeSortItem: {
      deep: true,
      handler() {
        this.currentPage = 1;
      },
    },
    fromDate() {
      this.fetchTransports();
    },
    toDate() {
      this.fetchTransports();
    },
  },
};
</script>

<style scoped>
.search-input {
  min-width: 300px;
}
</style>
<style scoped>
.light-gray {
  background: #f8f8f8;
}
.double-driving-candidates {
  white-space: nowrap;
}
.table-con {
  overflow-y: auto;
}
.total-price {
  text-align: right;
  font-size: 23px;
}
</style>
<style>
/* Tooltips are rendered outside the component, so this can't be scoped */
.savings-explanation-tooltip .tooltip-inner {
  max-width: 420px;
  text-align: left;
  white-space: pre-line;
}
</style>
<style scoped>
.savings-info-icon {
  cursor: help;
}
</style>
